import { GlobalMessages, TranslationGlobalMessages } from "@languages/interfaces/globalMessages";

export const messages: TranslationGlobalMessages = {
  [GlobalMessages.filtersText]: "Filtros",
  [GlobalMessages.activeText]: "Activo",
  [GlobalMessages.inactiveText]: "Inactivo",
  [GlobalMessages.saveText]: "Guardar",
  [GlobalMessages.columnActions]: "Actions",
  [GlobalMessages.buttonAdd]: "Añadir nuevo",
  [GlobalMessages.buttonDelete]: "Eliminar",
  [GlobalMessages.buttonRefresh]: "Actualizar",
  [GlobalMessages.buttonCancel]: "Cancelar",
  [GlobalMessages.buttonConfirm]: "Confirmar",
  [GlobalMessages.entityUser]: "Usuario",
  [GlobalMessages.yesText]: "Sí",
  [GlobalMessages.noText]: "No",
  [GlobalMessages.resetPasswordText]: "Restabelecer la contraseña",
  [GlobalMessages.logout]: "Cerrar sesión",
  [GlobalMessages.editUser]: "Editar usuario",
  [GlobalMessages.invalidFormInputs]: "Complete todas las informaciones obligatorias de la pestaña actual",
  [GlobalMessages.toastWarning]: "Advertencia",
  [GlobalMessages.errorText]: "Error",
  [GlobalMessages.warningTitleText]: "Advertencia",
  [GlobalMessages.selectAllText]: "Seleccionar todos",
  [GlobalMessages.removeAllText]: "Eliminar todos",
  [GlobalMessages.noRecordsFoundText]: "No se encontraron registros",
  [GlobalMessages.loading]: "Cargando...",
  [GlobalMessages.accessDenied]: "Acceso Denegado",
  [GlobalMessages.insufficientPermissions]: "No tienes permisos para realizar esta acción"
};
